import React, { useEffect, useRef } from 'react';

/** Fondo animado + resplandor que sigue al cursor (solo decorativo). */
export function BibleAura() {
  const glowRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (window.matchMedia('(pointer: coarse)').matches) return;
    const handleMove = (event: PointerEvent) => {
      const node = glowRef.current;
      if (!node) return;
      node.style.transform = `translate3d(${event.clientX - 260}px, ${event.clientY - 260}px, 0)`;
    };
    window.addEventListener('pointermove', handleMove, {
      passive: true
    });
    return () => window.removeEventListener('pointermove', handleMove);
  }, []);
  return <div aria-hidden="true" className="pointer-events-none fixed inset-0 z-0" data-id="element-8" data-mp="a7k24wbja9x5">
      {/* Capas con blur: solo en pantallas grandes, donde el coste de pintado no afecta al móvil. */}
      <div className="bible-aura-a absolute -left-40 -top-56 hidden h-[38rem] w-[38rem] rounded-full bg-[radial-gradient(circle,rgba(233,199,105,0.16),transparent_68%)] blur-3xl md:block" data-id="element-9" data-mp="2c2ksrycpfzxd" />
      <div className="bible-aura-b absolute -right-48 top-1/3 hidden h-[34rem] w-[34rem] rounded-full bg-[radial-gradient(circle,rgba(233,149,179,0.12),transparent_68%)] blur-3xl md:block" data-id="element-10" data-mp="3a5li0lx2fkv" />
      {/* Equivalente estático y barato para móvil. */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_80%_10%,rgba(233,199,105,0.10),transparent_60%)] md:hidden" data-id="element-11" data-mp="3lmk52v8pis34" />
      <div ref={glowRef} className="absolute left-0 top-0 hidden h-[520px] w-[520px] rounded-full bg-[radial-gradient(circle,rgba(233,199,105,0.07),transparent_62%)] blur-2xl will-change-transform md:block" data-id="element-12" data-mp="m6dtvda876ke" />
    </div>;
}